module.exports = __webpack_public_path__ + "static/media/ramon-barrera.60fe26b9.jpg";